let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gJW0s")).then(() => parcelRequire('a8jJ2'));